'use client';

import * as React from 'react';

import { cn } from '../lib/utils';
import {
  GithubMark,
  LinearMark,
  NotionMark,
  SlackMark,
} from './icons/brand-icons';

export type BrandService = 'notion' | 'linear' | 'github' | 'slack';

type BrandMarkProps = Omit<React.SVGAttributes<SVGSVGElement>, 'children'> & {
  service: BrandService;
};

/**
 * Compact brand mark for a known service. Delegates to the per-service
 * SVGs in `./icons/brand-icons` which use each brand's official palette.
 * Defaults to `size-3.5`; pass `className` to override.
 */
export function BrandMark({
  service,
  className,
  ...props
}: BrandMarkProps) {
  const merged = cn('size-3.5', className);
  switch (service) {
    case 'notion':
      return <NotionMark className={merged} {...props} />;
    case 'linear':
      return <LinearMark className={merged} {...props} />;
    case 'github':
      return <GithubMark className={merged} {...props} />;
    case 'slack':
      return <SlackMark className={merged} {...props} />;
  }
}

export type { BrandMarkProps };
